const parseMarkdownTable = (markdown) => {
    if (!markdown) {
        return { rows: [] };
    }
    const lines = markdown.trim().split('\n');

    const hasHeaders = lines[1] && lines[1].trim().match(/^\|[-:| ]+\|/);

    if (hasHeaders) {
        const headers = lines[0].trim().slice(1, -1).split('|').map(cell => cell.trim());
        const rows = lines.slice(2).map(line => line.trim().slice(1, -1).split('|').map(cell => cell.trim()));
        return { headers, rows };
    } else {
        const rows = lines.map(line => line.trim().slice(1, -1).split('|').map(cell => cell.trim()));
        return { rows };
    }
};

export default parseMarkdownTable;

